export const EVENTS: { [index: string]: string } = {
  CHANGED_CARD_DETAILS: 'changed card details',
  CONTACT_US: 'clicked contact us',
  DASHBOARD_VIEW_PLANS: 'clicked dashboard plans',
  DASHBOARD_VIEW_BILLING: 'clicked dashboard billing',
  ENTER_COUPON: 'applied coupon',
  INPUT_FOCUS: 'input focus',
  PAYMENT_FORM_ERROR: 'payment form error',
  PAYMENT_FORM_SUBMISSION: 'payment form submission',
  PAYMENT_FORM_SUCCESS: 'payment form success',
  SELECT_BILLING_CYCLE: 'selected a billing cycle',
  SELECT_COUNTRY: 'selected a country',
  SELECT_PLAN: 'selected a plan',
  VIEW_ALL_PLAN_FEATURES: 'clicked view all plan features',
  BILLED_YEARLY_PIONEERS: 'BilledYearly_PioneersPaymentsPage',
  BILLED_MONTHLY_PIONEERS: 'BilledMonthly_PioneersPaymentsPage',
  BILLED_YEARLY_PROFESSIONALS: 'BilledYearly_ProfessionalsPaymentsPage',
  BILLED_MONTHLY_PROFESSIONALS: 'BilledMonthly_ProfessionalsPaymentsPage',
  BUYNOW_PIONEERS: 'BuyNow_PioneersPaymentPage',
  BUYNOW_PROFESSIONALS: 'BuyNow_ProfessionalsPaymentPage',
  CHOOSE_PLAN_PIONEERS_PRODUCTCARD: 'ChoosePlan_PioneersTabBillingPage',
  CHOOSE_PLAN_PROFESSIONALS_PRODUCTCARD: 'ChoosePlan_ProfessionalsTabBillingPage',
  CHOOSE_PLAN_PIONEERS_PRODUCTFEATURE: 'ChoosePlan_PioneersExpandedBillingPage',
  CHOOSE_PLAN_PROFESSIONALS_PRODUCTFEATURE: 'ChoosePlan_ProfessionalsExpandedBillingPage',
  CLICK_TO_REFRESH_BILLING_FAIL: 'ClickToRefresh_BillingFail',
  HAVEVOUCHERCODE_PIONEERS: 'HaveVoucherCode_PioneersPaymentsPage',
  HAVEVOUCHERCODE_PROFESSIONALS: 'HaveVoucherCode_ProfessionalsPaymentsPage',
};

const segmentEnabled = (window as any).analytics && process.env.REACT_APP_SEGMENT_KEY;
if (segmentEnabled) {
  (window as any).analytics.load(process.env.REACT_APP_SEGMENT_KEY);
  (window as any).analytics.page();
}

export const identify = (userId: string, traits: any) => {
  if (segmentEnabled) {
    (window as any).analytics.identify(userId, traits);
  }
};

export const track = (event: string, properties?: any) => {
  if (segmentEnabled) {
    (window as any).analytics.track(event, properties);
  }
};

export const page = (name?: string, properties?: any) => {
  if (segmentEnabled) {
    (window as any).analytics.page(name, properties);
  }
};
